import RoutesMap from "route_control/RouteControl"
import {
    AuditLogList,
    InOutReport,
    UserStatusReport,
    AdminReport,
    FinancialReport,
    OccupancyReport,
    TicketResolutionReport,
    VisitorTrafficReport,
    MonitoringAndLogs,
    AuditTrail,
    PlatformAnalytics,
} from "pages/report"

const ReportRoute = () => {
    return [
        {
            path: RoutesMap.AUDIT_LOG_LIST.path,
            element: <AuditLogList />
        },
        {
            path: RoutesMap.IN_OUT_LOG_LIST.path,
            element: <InOutReport />
        },
        {
            path: RoutesMap.USER_STATUS_LIST.path,
            element: <UserStatusReport />
        },
        {
            path: RoutesMap.ADMIN_REPORT.path,
            element: <AdminReport />
        },
        {
            path: RoutesMap.FINANCIAL_REPORT.path,
            element: <FinancialReport />
        },
        {
            path: RoutesMap.OCCUPANCY_REPORT.path,
            element: <OccupancyReport />
        },
        {
            path: RoutesMap.TICKET_RESOLUTION_REPORT.path,
            element: <TicketResolutionReport />
        },
        {
            path: RoutesMap.VISITOR_TRAFFIC_REPORT.path,
            element: <VisitorTrafficReport />
        },
        {
            path: RoutesMap.MONITORING_AND_LOGS.path,
            element: <MonitoringAndLogs />
        },
        {
            path: RoutesMap.AUDIT_TRAIL.path,
            element: <AuditTrail />
        },
        {
            path: RoutesMap.PLATFORM_ANALYTICS.path,
            element: <PlatformAnalytics />
        },
    ]
}

export default ReportRoute;